"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = void 0;
var Environment;
(function (Environment) {
    Environment["development"] = "development";
    Environment["test"] = "test";
    Environment["staging"] = "staging";
    Environment["production"] = "production";
})(Environment || (exports.Environment = Environment = {}));
